import React from "react";
import { connect } from "react-redux";
import { styles } from "../../styles/request_details";
import Loader from "components/Loading";
import { LightThemeTable } from "components/LightThemeTable";
import Constants from "helpers/constants";
import AssignChainStore from "./AssignChainStore";
import { checkOnboardUser } from "state/request_details_dependencies";
import SystemAdminApproval from "./SystemAdminApproval";
import SelectChainStoreInfo, { AssignmentData } from "./SelectChainStoreInfo";
import UserOnboarding from "./userOnboarding";
import "../../styles/request_dashboard.scss";

interface AssignChainStoreApprovalProps {
    isProcessing: boolean;
    onReject: () => void;
    onApprove: () => void;
    stage: any;
    onSuccess: () => void;
    onCheckOnboardUser: (emails: string | string[]) => Promise<any>;
    handleSubmitProjectAdminAssignment: (data: AssignmentData) => Promise<void>;
}

interface UserRow {
    email?: string;
    storeIds?: (string | number)[];
}

interface OnboardUserCheckResult {
    totalCount: number;
    availableCount: number;
    notAvailableCount: number;
    availableUsers: { id: number; email: string; first_name: string; last_name: string }[];
    notAvailableEmails: string[];
}

interface AssignChainStoreApprovalState {
    isRejectHovered: boolean;
    isApproveHovered: boolean;
    isModalOpen: boolean;
    isOnboardingModalOpen: boolean;
    users: UserRow[];
    activeAction: "approve" | "reject" | null;
    onboardUserCheck: OnboardUserCheckResult | null;
    isSelectChainStoreModalOpen: boolean;
}

class AssignChainStoreApproval extends React.Component<
    AssignChainStoreApprovalProps,
    AssignChainStoreApprovalState
> {
    constructor(props: AssignChainStoreApprovalProps) {
        super(props);
        this.state = {
            isRejectHovered: false,
            isApproveHovered: false,
            isModalOpen: false,
            isOnboardingModalOpen: false,
            activeAction: null,
            onboardUserCheck: null,
            isSelectChainStoreModalOpen: false,
            users: [
                {
                    email: props.stage?.requestorEmail ?? props.stage?.usersData?.[0]?.user_email,
                    storeIds: props.stage?.stores ?? props.stage?.usersData?.[0]?.storeIds,
                },
            ],
        };
    }

    // API Call Helper

    // private callCheckOnboardUser = (stage: any): void => {
    //     const { onCheckOnboardUser } = this.props;

    //     const emails: string[] = (stage?.onboardUserData ?? [])
    //         .map((user: any) => user?.user_email)
    //         .filter(Boolean);

    //     if (emails.length > 0) {
    //         onCheckOnboardUser(emails)
    //             .then((result: OnboardUserCheckResult) => this.setState({ onboardUserCheck: result }))
    //             .catch((error: any) => console.error("checkOnboardUser error:", error));
    //     } else {
    //         console.warn("No valid emails found in stage.onboardUserData");
    //     }
    // };


    componentDidMount(): void {
        // this.callCheckOnboardUser(this.props.stage);
    }

    componentDidUpdate(prevProps: AssignChainStoreApprovalProps): void {
        if (prevProps.stage !== this.props.stage) {
            const { stage } = this.props;

            this.setState({
                users: [
                    {
                        email: stage?.requestorEmail ?? stage?.usersData?.[0]?.user_email,
                        storeIds: stage?.stores ?? stage?.usersData?.[0]?.storeIds,
                    },
                ],
                onboardUserCheck: null,
            });

            // this.callCheckOnboardUser(stage);
        }

        if (prevProps.isProcessing && !this.props.isProcessing) {
            this.setState({ activeAction: null });
        }
    }

    // Event Handlers 

    handleRejectMouseEnter = (): void => { if (!this.props.isProcessing) this.setState({ isRejectHovered: true }); };
    handleRejectMouseLeave = (): void => { this.setState({ isRejectHovered: false }); };
    handleApproveMouseEnter = (): void => { if (!this.props.isProcessing) this.setState({ isApproveHovered: true }); };
    handleApproveMouseLeave = (): void => { this.setState({ isApproveHovered: false }); };

    handleOpenModal = (): void => this.setState({ isModalOpen: true });
    handleCloseModal = (): void => this.setState({ isModalOpen: false });
    handleOpenOnboardingModal = (): void => this.setState({ isOnboardingModalOpen: true });
    handleCloseOnboardingModal = (): void => this.setState({ isOnboardingModalOpen: false });

    handleReject = (): void => { this.setState({ activeAction: "reject" }); this.props.onReject(); };
    handleApprove = (): void => { this.setState({ activeAction: "approve" }); this.props.onApprove(); };

    handleOpenSelectChainStoreModal = (): void => this.setState({ isSelectChainStoreModalOpen: true });
    handleCloseSelectChainStoreModal = (): void => this.setState({ isSelectChainStoreModalOpen: false });

    handleSubmitSelectChainStore = async (): Promise<void> => {
        await this.props.onSuccess();
        this.setState({ isSelectChainStoreModalOpen: false });
    };

    handleOnboardingSuccess = (): void => {
        this.props.onSuccess();
        this.setState({ isOnboardingModalOpen: false });
        // this.callCheckOnboardUser(this.props.stage);
    };

    private getPendingTaskCount = (): number => {
        const { stage } = this.props;
        const tasks = stage?.requestTasks ?? [];
        return tasks.filter((t: any) => !t.isTaskCompleted).length;
    };

    private isTaskCompleted = (taskCode: string): boolean => {
        const { stage } = this.props;
        const tasks = stage?.requestTasks ?? [];
        const task = tasks.find((t: any) => t.task_code === taskCode);
        return task ? task.isTaskCompleted : false;
    };

    // Visibility Logic

    private getProjectAdminVisibility = () => {
        const { stage } = this.props;
        if (!stage) return { showAssociationAction: false, showApproval: false, showOnboardAndAssciation: false };

        const { action_code, approver_status } = stage;
        const isApproved = approver_status === Constants.STAGE_APPROVED;
        const isApprovalAction = action_code === Constants.ACTION_CODE_APPROVAL;

        return {
            showAssociationAction:
                action_code === Constants.APPROVAL_AND_ACTION_CHAIN_ASSOCIATION
                    ? isApproved
                    : action_code === Constants.ACTION_ONLY_CHAIN_ASSOCIATION,
            showApproval:
                action_code === Constants.APPROVAL_AND_ACTION_CHAIN_ASSOCIATION && !isApproved,
            showOnboardAndAssciation:
                action_code === Constants.ACTION_ONLY_USER_ONBOARDING_AND_CHAIN_ASSOCIATION,
            isApprovalOnly: isApprovalAction && approver_status === Constants.STAGE_PENDING,
            isChainStoreSelection: isApprovalAction && isApproved,
        };
    };

    // Shared UI Helpers 

    private renderAlertBanner = () => (
        <div className="acsa-alert">
            <span className="acsa-alert-icon">!</span>
            Complete all required actions to complete request.
        </div>
    );

    private renderCircleBadge = (label: number) => (
        <span style={{
            width: 24, height: 24, borderRadius: "50%",
            backgroundColor: "#F3F4F6", border: "1px solid #E5E7EB",
            color: "#1F2937", display: "flex", alignItems: "center",
            justifyContent: "center", fontSize: 14, fontWeight: 600, flexShrink: 0,
        }}>
            {label}
        </span>
    );

    private renderGreenCheck = () => (
        <span style={{
            width: 24, height: 24, borderRadius: "50%",
            backgroundColor: "#D1FAE5", border: "1px solid #10B981",
            color: "#10B981", display: "flex", alignItems: "center",
            justifyContent: "center", fontSize: 14, fontWeight: 700, flexShrink: 0,
        }}>
            ✓
        </span>
    );

    private renderApprovalCard = (chainName: string, users: UserRow[], columns: any[]) => (
        <div className="acsa-info-card">
            <div className="acsa-chain-meta">
                <div><span style={{ fontWeight: 600 }}>Chain Name:</span> {chainName}</div>
            </div>
            <div style={{ marginTop: "16px", marginBottom: "24px" }}>
                <LightThemeTable
                    data={users}
                    columns={columns}
                    pageSizeOptions={[5, 10, 20]}
                    isLoading={false}
                />
            </div>
        </div>
    );

    private renderApproveRejectButtons = (
        isProcessing: boolean,
        isApprovingLoading: boolean,
        rejectButtonStyle: React.CSSProperties
    ) => (
        <div className="acsa-btn-group">
            <button
                style={rejectButtonStyle}
                onClick={this.handleReject}
                disabled={isProcessing}
                onMouseEnter={this.handleRejectMouseEnter}
                onMouseLeave={this.handleRejectMouseLeave}
                aria-label="Reject request"
            >
                Reject
            </button>
            <div style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
                <span style={{
                    display: "inline-flex", width: 20, height: 20,
                    alignItems: "center", justifyContent: "center",
                    visibility: isApprovingLoading ? "visible" : "hidden",
                }} aria-hidden={!isApprovingLoading}>
                    {isApprovingLoading && <Loader height={20} width={20} custom={true} />}
                </span>
                <button
                    className="primary-button"
                    onClick={this.handleApprove}
                    disabled={isProcessing}
                    onMouseEnter={this.handleApproveMouseEnter}
                    onMouseLeave={this.handleApproveMouseLeave}
                    aria-label={isApprovingLoading ? "Approving request" : "Approve request"}
                    aria-busy={isApprovingLoading || undefined}
                    style={{
                        whiteSpace: "nowrap",
                        minWidth: 130,
                        opacity: isApprovingLoading ? 0.6 : 1,
                        cursor: isProcessing ? "not-allowed" : "pointer",
                    }}
                >
                    {isApprovingLoading ? "Configuring Access..." : "Configure Access"}
                </button>
            </div>
        </div>
    );

    render(): React.ReactNode {
        const { isProcessing, stage } = this.props;
        const {
            isRejectHovered, isModalOpen, users, activeAction,
            isOnboardingModalOpen, onboardUserCheck,
        } = this.state;

        const {
            showAssociationAction, showApproval, showOnboardAndAssciation,
            isApprovalOnly, isChainStoreSelection,
        } = this.getProjectAdminVisibility();

        const isApprovingLoading = isProcessing && activeAction === "approve";
        const chainName = stage?.chainName;

        const allUsersOnboarded =
            onboardUserCheck !== null &&
            onboardUserCheck.totalCount === onboardUserCheck.availableCount;

        const rejectButtonStyle: React.CSSProperties = {
            ...styles.rejectButton,
            ...(isProcessing && styles.buttonDisabled),
            ...(isRejectHovered && !isProcessing && { textDecoration: "underline" }),
        };

        const columns = [
            {
                field: "email",
                header: "Email",
                formatter: (_: any, row: any) => (
                    <div style={{ padding: "8px", wordBreak: "break-all" }}>{row.email}</div>
                ),
            },
            {
                field: "storeIds",
                header: "Store IDs",
                formatter: (_: any, row: any) => (
                    <div style={{ padding: "8px" }}>
                        {row.storeIds && row.storeIds.length > 0 ? row.storeIds.join(", ") : "-"}
                    </div>
                ),
            },
        ];

        return (
            <>
                <div className="acsa-wrapper" style={styles.rejectSection}>
                    <div className="acsa-content" style={styles.rejectContent}>

                        {/* Approval Section */}
                        {showApproval && (
                            <>
                                <h3 style={styles.rejectHeading}>Request is in Pending status</h3>
                                <p style={styles.rejectText}>
                                    Review the user details and requested access. You can approve or reject this request.
                                </p>
                                {this.renderApprovalCard(chainName, users, columns)}
                                {this.renderApproveRejectButtons(isProcessing, isApprovingLoading, rejectButtonStyle)}
                            </>
                        )}

                        {/* Association Only */}
                        {showAssociationAction && !isApprovalOnly && (
                            <>
                                {this.renderAlertBanner()}
                                <div className="acsa-section-heading">
                                    <h4>Required actions</h4>
                                    {this.renderCircleBadge(this.getPendingTaskCount())}
                                </div>
                                <div
                                    className="acsa-action-row"
                                    style={{ borderBottom: "1px solid #F3F4F6" }}
                                >
                                    <div className="acsa-action-row-label">
                                        {this.renderCircleBadge(1)}
                                        <span>Assign Chain and Store</span>
                                    </div>
                                    <button className="primary-button" onClick={this.handleOpenModal}>
                                        Assign Chain and Store
                                    </button>
                                </div>
                            </>
                        )}

                        {/* Onboard + Association */}
                        {showOnboardAndAssciation && (() => {
                            const onboardingDone = this.isTaskCompleted("USER_ONBOARDING");
                            const assignDone = this.isTaskCompleted("CHAIN_ASSOCIATION");

                            return (
                                <>
                                    {this.renderAlertBanner()}

                                    <div className="acsa-section-heading">
                                        <h4>Required actions</h4>
                                        {this.renderCircleBadge(this.getPendingTaskCount())}
                                    </div>

                                    {/* User Onboarding row */}
                                    <div
                                        className="acsa-action-row"
                                        style={{ borderBottom: "1px solid #F3F4F6" }}
                                    >
                                        <div className="acsa-action-row-label">
                                            {onboardingDone ? this.renderGreenCheck() : this.renderCircleBadge(1)}
                                            <span style={{ color: onboardingDone ? "#10B981" : "#1F2937" }}>
                                                User Onboarding
                                            </span>
                                            {onboardingDone && (
                                                <span style={{
                                                    fontSize: "11px", fontWeight: 600, color: "#10B981",
                                                    backgroundColor: "#D1FAE5", border: "1px solid #10B981",
                                                    borderRadius: "12px", padding: "2px 10px",
                                                    whiteSpace: "nowrap",
                                                }}>
                                                    Completed
                                                </span>
                                            )}
                                        </div>
                                        <button
                                            className="primary-button"
                                            onClick={this.handleOpenOnboardingModal}
                                            disabled={onboardingDone}
                                            style={{
                                                opacity: onboardingDone ? 0.45 : 1,
                                                cursor: onboardingDone ? "not-allowed" : "pointer",
                                                flexShrink: 0,
                                            }}
                                        >
                                            User Onboarding
                                        </button>
                                    </div>

                                    {/* Assign Chain and Store row */}
                                    <div
                                        className="acsa-action-row"
                                        style={{ opacity: onboardingDone ? 1 : 0.45 }}
                                    >
                                        <div className="acsa-action-row-label">
                                            {assignDone ? this.renderGreenCheck() : this.renderCircleBadge(2)}
                                            <span style={{ color: assignDone ? "#10B981" : "#1F2937" }}>
                                                Assign Chain and Store
                                            </span>
                                            {assignDone && (
                                                <span style={{
                                                    fontSize: "11px", fontWeight: 600, color: "#10B981",
                                                    backgroundColor: "#D1FAE5", border: "1px solid #10B981",
                                                    borderRadius: "12px", padding: "2px 10px",
                                                    whiteSpace: "nowrap",
                                                }}>
                                                    Completed
                                                </span>
                                            )}
                                        </div>
                                        <button
                                            className="primary-button"
                                            onClick={this.handleOpenModal}
                                            disabled={!onboardingDone || assignDone}
                                            style={{
                                                cursor: (onboardingDone && !assignDone) ? "pointer" : "not-allowed",
                                                opacity: (!onboardingDone || assignDone) ? 0.45 : 1,
                                                flexShrink: 0,
                                            }}
                                        >
                                            Assign Chain and Store
                                        </button>
                                    </div>
                                </>
                            );
                        })()}

                        {/* Approval Only */}
                        {isApprovalOnly && (
                            <>
                                <h3 style={styles.rejectHeading}>Request is in Pending status</h3>
                                <p style={styles.rejectText}>
                                    Review the user details and requested access. You can approve or reject this request.
                                </p>
                                {this.renderApprovalCard(chainName, users, columns)}
                                {this.renderApproveRejectButtons(isProcessing, isApprovingLoading, rejectButtonStyle)}
                            </>
                        )}

                        {/* Chain Store Selection */}
                        {isChainStoreSelection && (
                            <SystemAdminApproval
                                isProcessing={isProcessing}
                                onReject={this.props.onReject}
                                onOpenAssignModal={this.handleOpenSelectChainStoreModal}
                                stage={this.props.stage}
                            />
                        )}
                    </div>
                </div>
                <SelectChainStoreInfo
                    isOpen={this.state.isSelectChainStoreModalOpen}
                    onClose={this.handleCloseSelectChainStoreModal}
                    onSubmit={this.props.handleSubmitProjectAdminAssignment}
                    stage={this.props.stage}
                />
                <AssignChainStore
                    isOpen={isModalOpen}
                    onClose={this.handleCloseModal}
                    stage={this.props.stage}
                    onSuccess={this.props.onSuccess}
                />
                <UserOnboarding
                    isOpen={isOnboardingModalOpen}
                    onClose={this.handleCloseOnboardingModal}
                    data={stage}
                    onSuccess={this.handleOnboardingSuccess}
                />
            </>
        );
    }
}

const mapDispatchToProps = (dispatch: any) => ({
    onCheckOnboardUser: (emails: string | string[]) => dispatch(checkOnboardUser(emails)),
});

export default connect(null, mapDispatchToProps)(AssignChainStoreApproval);